import { mapState } from 'vuex';
import ApiService from '@/services/apiService';
const DEFAULT_TAG_ITEMS = ['Building', 'Room', 'Door', 'School', 'accessMgmt', 'District'];
export default {
  name: 'CoreTags',
  props: {
    tags: {
      type: Array,
      required: true
    },
    externalTags: {
      type: Array,
      default: () => [],
      required: false
    },
    additionalItems: {
      type: Array,
      default: () => [],
      required: false
    },
    label: {
      type: String,
      default: '',
      required: false
    },
    tagListType: {
      type: String,
      default: 'digitalTwin',
      required: false
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    height: {
      type: [String, Number],
      default: 'auto',
      required: false
    },
    dataCy: {
      type: String,
      default: '',
      required: false
    }
  },
  data: function () {
    return {
      search: '',
      internalTags: this.tags,
      tagItems: DEFAULT_TAG_ITEMS
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'color'])
  },
  watch: {
    tags: {
      handler: function (newVal) {
        this.internalTags = newVal;
      }
    }
  },
  mounted() {
    this.fetchTagList();
  },
  methods: {
    process() {
      this.search = '';
      const cleanTags = this.internalTags
      // remove empty and non-string tag items
      .filter(tag => {
        if (typeof tag !== 'string') {
          if (this.additionalItems.find(item => item.value === tag.value)) {
            return true;
          }
          return false;
        }
        return tag.trim() !== '';
      })
      // trim whitespace from tags
      .map(tag => {
        if (typeof tag !== 'string') {
          return tag.value;
        }
        return tag.trim();
      });

      // remove any duplicates from tags
      this.internalTags = [...new Set(cleanTags)];
      this.$emit('update:tags', this.internalTags);
    },
    remove(item) {
      if (this.externalTags.includes(item)) {
        return;
      }
      this.internalTags.splice(this.internalTags.indexOf(item), 1);
      this.internalTags = [...this.internalTags];
      this.process();
    },
    async fetchTagList() {
      const apiMethod = this.tagListType === 'digitalTwin' ? ApiService.digitalTwinFetchTagsAndZones : ApiService.virtualDeviceFetchTags;
      try {
        const result = await apiMethod();
        let nextTagItems = result.tagList || [];
        if (this.externalTags.length > 0) {
          nextTagItems = nextTagItems.map(tag => {
            return {
              text: tag,
              value: tag,
              disabled: this.externalTags.includes(tag)
            };
          });
        }
        this.tagItems = [...this.additionalItems, ...nextTagItems];
      } catch (error) {
        console.error(error);
        this.$snack(this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.snacks.fetchTagsError'), 'error');
      }
    },
    restrictCharacters(event) {
      if (event.key === ',' || event.key === ';') {
        event.preventDefault();
      }
    }
  }
};